export default __webpack_public_path__ + "static/media/fishfood1.5dfb8810.jpg";